import { Plugin } from 'prosemirror-state'
import { Decoration, DecorationSet } from 'prosemirror-view'
import { matcher } from './matcher'
import { MentionsView } from './MentionsView'
import { ANCHOR_DATA_ATTR, MENTIONS_PLUGIN_KEY } from './constants'
import { QueryClient } from 'react-query'

type Config = {
  queryClient: QueryClient
}

export function MentionsPlugin(config: Config) {
  return new Plugin({
    key: MENTIONS_PLUGIN_KEY,
    state: {
      init() {
        return {
          active: false,
          range: null,
          text: null,
        }
      },
      apply(tr) {
        const { selection } = tr

        if (selection.from === selection.to) {
          const match = matcher(selection.$from)

          if (match) {
            return {
              active: true,
              range: match.range,
              text: match.text.slice(1),
            }
          }
        }

        return {
          active: false,
          range: null,
          text: null,
        }
      },
    },
    view(view) {
      return new MentionsView(view, config.queryClient)
    },
    props: {
      decorations(editorState) {
        const state = MENTIONS_PLUGIN_KEY.getState(editorState)
        if (!state?.active || !state.range) {
          return DecorationSet.empty
        }
        return DecorationSet.create(editorState.doc, [
          Decoration.inline(state.range.from, state.range.to, { [ANCHOR_DATA_ATTR]: 'true' }),
        ])
      },
      handleKeyDown(view, event) {
        const state = MENTIONS_PLUGIN_KEY.getState(view.state)
        if (!state?.active) {
          return false
        }
        return ['ArrowDown', 'ArrowUp', 'Enter', 'Tab'].includes(event.key)
      },
    },
  })
}
